<template>
  <v-card class="left-vertical-card">
    <div class="d-flex bg-titre">
      <div class="align-self-center pl-3 mr-auto">
        <div class="d-flex flex-column">
          <div class="titre-h3 secondary--text ">
            Itinéraire technique
          </div>
          <div class="titre-h5 secondary--text ">
            Semences <span class="secondary--text align-self-center ">({{ densiteSemis.typeCulture.nom }})</span>
          </div>
        </div>
      </div>
      <v-btn
        class="align-self-center"
        text
        @click="onClose"
      >
        <v-icon color="secondary">
          mdi-close
        </v-icon>
      </v-btn>
    </div>
    
    <div class="d-flex flex-column mt-3 mx-4">
      <v-card
        class="pa-2 mb-2 background"
      >
        <div class="d-flex justify-space-between">
          <div class="secondary--text titre-h5">
            Densité de semis
            <v-chip
              small
              
              color="secondary"
            >
              <span class="text-lowercase">
                {{ densiteSemis.typeRubrique.statut | capitalize }}
              </span>
            </v-chip>
          </div>
          <AgrButton
            icon
            @click="onOpenUpdateParametreModal()"
          >
            <v-icon color="grey darken-2">
              mdi-pencil-outline
            </v-icon>
          </AgrButton>
        </div>
        <div class="d-flex justify-space-between">
          <div class="texte py-0 texte-gris-fonce font-weight-light">
            Valeur min
          </div>
          <div class="align-self-center texte py-0 secondary--text font-weight-light">
            {{ densiteSemis.valeurMin != null ? densiteSemis.valeurMin : '-' }} {{ densiteSemis.unite }}
          </div>
        </div>
        <div class="d-flex justify-space-between">
          <div class="texte py-0 texte-gris-fonce">
            Valeur défaut
          </div>
          <div class="align-self-center texte py-0 secondary--text">
            {{ densiteSemis.valeurDefaut != null ? densiteSemis.valeurDefaut : '-' }} {{ densiteSemis.unite }}
          </div>
        </div>
        <div class="d-flex justify-space-between">
          <div class="texte py-0 texte-gris-fonce font-weight-light">
            Valeur max
          </div>
          <div class="align-self-center texte py-0 secondary--text font-weight-light">
            {{ densiteSemis.valeurMax != null ? densiteSemis.valeurMax : '-' }} {{ densiteSemis.unite }}
          </div>
        </div>
        <div class="d-flex justify-space-between">
          <div class="texte py-0 texte-gris-fonce font-weight-light">
            Valeur économique
          </div>
          <div class="align-self-center texte py-0 secondary--text font-weight-light">
            {{ densiteSemis.valeurEconomique != null ? densiteSemis.valeurEconomique : '-' }} €/ha
          </div>
        </div>
      </v-card>
      <div class="d-flex justify-space-around my-4">
        <AgrButton
          class="pa-5"
          outlined
          block
          @click="onClose()"
        >
          Fermer
        </AgrButton>
      </div>
    </div>
    <v-dialog
      v-if="isUpdateParametreModalOpen"
      v-model="isUpdateParametreModalOpen"
      width="500"
    >
      <UpdateParametreModal
        :parametre="densiteSemis"
        @close="closeModalNouveauParametre()"
        @updatedParametre="updatedParametre"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import { AgrButton } from '@agrial/ui'
import UpdateParametreModal from './update-parametre-modal.vue'

export default {
  name: 'UpdateDensiteSemisModal',
  components: {AgrButton, UpdateParametreModal},
  props: {
    densiteSemis: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      isUpdateParametreModalOpen: false,
      parametre: null,
      rules: {
        required: value => (value !== null && value !== '') || 'Champ requis',
      }
    }
  },
  methods: { 
    onClose () {
      this.$emit('close')
    },
    closeModalNouveauParametre () {
      this.isUpdateParametreModalOpen = false
    },
    onOpenUpdateParametreModal () {
      this.isUpdateParametreModalOpen = true
    },
    updatedParametre () {
      this.$emit('updatedParametre', this.densiteSemis.typeCulture.id)
      this.isUpdateParametreModalOpen = false
    }
  }
}
</script>
<style lang="scss" scoped>
.left-vertical-card {
  border-radius: 0 !important;
}

.background {
  background: #EFF0E1;
}

.bg-titre {
  height: 70px;
  background-color: #f1f2f5;
}

.input-number {
  width: 100%;
}
</style>
